import { useState, useEffect } from 'react';
import { useAccount } from '../contexts/AccountContext';
import { useCart } from '../contexts/CartContext';
import { useApiCall } from './useApiCall';

/**
 * Custom hook to fetch and manage cart and wishlist counts
 * @returns {Object} - { cartCount, wishlistCount, isLoading }
 */
export const useCounts = () => {
  const { account } = useAccount();
  const { refreshTrigger } = useCart();
  const apiCall = useApiCall();
  
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch counts when account changes or refreshTrigger updates
  useEffect(() => {
    if (!account) {
      setCartCount(0);
      setWishlistCount(0);
      return;
    }

    setIsLoading(true);
    
    const fetchCounts = async () => {
      try {
        const countsResponse = await apiCall('account/counts', 'POST', {}, account, null);
        if (countsResponse.success && countsResponse.data) {
          setCartCount(countsResponse.data.cart_count || 0);
          setWishlistCount(countsResponse.data.wishlist_count || 0);
        }
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };

    fetchCounts();
  }, [account, refreshTrigger]);

  return {
    cartCount,
    wishlistCount,
    isLoading
  };
};
